import { AfterContentInit, Directive, ElementRef, Input } from '@angular/core';
import { Observable } from 'rxjs';

@Directive({
  selector: '[appAutofocus]'
})
export class AutofocusDirective implements AfterContentInit {

  @Input()
  set appAutofocus(o: Observable<void>) { }

  constructor(private el: ElementRef) {
    this.el.nativeElement.focus();
  }

  ngAfterContentInit(): void {
    setTimeout(() => {
      this.el.nativeElement.focus();
    }, 500);
  }

}
